import { FunctionComponent, useState } from "react";
import "./top-menu.scss";

import MenuItem from "./menu-item";
import FeatureMenu from "../../features/feature-menu";
import A from "../html-tags/a";
import { Box, IconButton, Stack } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "./Sidebar";

export type MenuItems =
  | "home"
  | "help"
  | "features"
  | "solutions"
  | "prices"
  | "education"
  | "freetrial"
  | "contact"
  | "news"
  | "about"
  | "terms"
  | "legal"
  | "privacy"
  | "cookies";

export type Languages = "de" | "en";

export type Props = {
  selected: MenuItems | undefined;
};

const TopMenu: FunctionComponent<Props> = (props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <>
      <div className="top-menu-wrapper">
        <div className="top-menu">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              alignSelf="center"
            >
              <IconButton
                sx={{
                  display: {
                    xs: "flex",
                    md: "none",
                  },
                }}
                onClick={openSidebar}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <div className="top-menu-logo">
              <A language="de" href={"/de/home"}>
                <img src="/img/2x4logo_256x256.png" alt="2x4 Logo" />
                <span>
                  PS IMAGO <b style={{ color: "crimson" }}>PRO</b>
                </span>
              </A>
              <A language="en" href={"/en/home"}>
                <img src="/img/2x4logo_256x256.png" alt="2x4 Logo" />
                <span>
                  PS IMAGO <b style={{ color: "crimson" }}>PRO</b>
                </span>
              </A>
            </div>
          </Stack>
          <Box
            component="ul"
            sx={{
              display: {
                xs: "none",
                md: "flex",
              },
            }}
          >
            {/* = Home ==================================================================== */}
            <MenuItem
              selected={props.selected}
              menuName={"home"}
              labels={[
                { language: "de", label: "Hauptseite" },
                { language: "en", label: "Home" },
              ]}
            />

            {/* = Features ================================================================ */}
            <MenuItem
              selected={props.selected}
              menuName={"features"}
              labels={[
                { language: "de", label: "Features" },
                { language: "en", label: "Features" },
              ]}
              submenu={() => <FeatureMenu />}
            />

            {/* = Free Trial ============================================================== */}
            <MenuItem
              selected={props.selected}
              menuName={"freetrial"}
              labels={[
                { language: "de", label: "Kostenloser Test" },
                { language: "en", label: "Free Trial" },
              ]}
            />

            {/* = Prices ================================================================== */}
            <MenuItem
              selected={props.selected}
              menuName={"prices"}
              labels={[
                { language: "de", label: "Preise" },
                { language: "en", label: "Prices" },
              ]}
            />

            {/* = Education =============================================================== */}
            <MenuItem
              selected={props.selected}
              menuName={"education"}
              labels={[
                { language: "de", label: "Lernen" },
                { language: "en", label: "Education" },
              ]}
            />

            {/* = Contact ================================================================= */}
            <MenuItem
              selected={props.selected}
              menuName={"contact"}
              labels={[
                { language: "de", label: "Kontakt" },
                { language: "en", label: "Contact" },
              ]}
            />

            {/* = News ==================================================================== */}
            <MenuItem
              selected={props.selected}
              menuName={"news"}
              labels={[
                { language: "de", label: "News" },
                { language: "en", label: "News" },
              ]}
            />
          </Box>
        </div>
      </div>
      <Sidebar
        menuItems={[
          {
            menuName: "home",
            labels: [
              { language: "de", label: "Hauptseite" },
              { language: "en", label: "Home" },
            ],
            route: "/home",
          },
          {
            menuName: "features",
            labels: [
              { language: "de", label: "Features" },
              { language: "en", label: "Features" },
            ],
            route: "/features",
            subItems: [
              {
                menuName: "features/management",
                labels: [
                  { language: "de", label: "Datenaufbereitung" },
                  { language: "en", label: "Data Management" },
                ],
                route: "/features/management",
              },
              {
                menuName: "features/analysis",
                labels: [
                  { language: "de", label: "Datenanalyse" },
                  { language: "en", label: "Data Analysis" },
                ],
                route: "/features/analysis",
              },
              {
                menuName: "features/reporting",
                labels: [
                  { language: "de", label: "Ergebnispräsentation" },
                  { language: "en", label: "Reporting" },
                ],
                route: "/features/reporting",
              },
              {
                menuName: "features/deployment",
                labels: [
                  { language: "de", label: "Verteilung und Verwaltung" },
                  { language: "en", label: "deployment" },
                ],
                route: "/features/deployment",
              },
              {
                menuName: "features/publish",
                labels: [
                  {
                    language: "de",
                    label: "Veröffentlichung und Automatisierung",
                  },
                  { language: "en", label: "Deployment & Automation" },
                ],
                route: "/features/publish",
              },
            ],
          },
          {
            menuName: "freetrial",
            labels: [
              { language: "de", label: "Kostenloser Test" },
              { language: "en", label: "Free Trial" },
            ],
            route: "/freetrial",
          },
          {
            menuName: "prices",
            labels: [
              { language: "de", label: "Preise" },
              { language: "en", label: "Prices" },
            ],
            route: "/prices",
          },
          {
            menuName: "education",
            labels: [
              { language: "de", label: "Lernen" },
              { language: "en", label: "Education" },
            ],
            route: "/education",
          },
          {
            menuName: "contact",
            labels: [
              { language: "de", label: "Kontakt" },
              { language: "en", label: "Contact" },
            ],
            route: "/contact",
          },
          {
            menuName: "news",
            labels: [
              { language: "de", label: "News" },
              { language: "en", label: "News" },
            ],
            route: "/news",
          },
        ]}
        onClose={closeSidebar}
        open={isSidebarOpen}
        languageHandler={(menuItem, language) =>
          menuItem.labels.find((label) => label.language === language)?.label ||
          menuItem.labels[0].label
        }
        currentLanguage={window.location.href.split("/")[3] as Languages}
      />
    </>
  );
};

export default TopMenu;
